"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorizeWithCSSFilter = exports.accessibleTextColor = exports.fadedColor = exports.alternateColor = exports.colorCanLighten = exports.colorCanDarken = exports.colorsAreAccessible = exports.almostBlackColor = exports.almostWhiteColor = exports.setLuminoscity = exports.hslObject = exports.isColor = void 0;

var _color = _interopRequireDefault(require("color"));

var _hexToCssFilter = _interopRequireDefault(require("hex-to-css-filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var minimumLuminoscity = 10;
var maximumLuminoscity = 65;
var white = (0, _color["default"])('white');
var black = (0, _color["default"])('black');

var isColor = function isColor(color) {
  if (!color) {
    return false;
  }

  try {
    (0, _color["default"])(color);
    return true;
  } catch (_unused) {
    return false;
  }
};

exports.isColor = isColor;

var hslObject = function hslObject(color) {
  return (0, _color["default"])(color).hsl().object();
};

exports.hslObject = hslObject;

var setLuminoscity = function setLuminoscity(color, luminoscity) {
  return _color["default"].hsl(_objectSpread({}, hslObject(color), {
    l: luminoscity
  }));
};

exports.setLuminoscity = setLuminoscity;

var almostWhiteColor = function almostWhiteColor(color) {
  return setLuminoscity(color, 95);
};

exports.almostWhiteColor = almostWhiteColor;

var almostBlackColor = function almostBlackColor(color) {
  return setLuminoscity(color, 15);
};

exports.almostBlackColor = almostBlackColor;

var colorsAreAccessible = function colorsAreAccessible(foreground, background) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'AA';
  var ratio = level === 'AAA' ? 7 : 4.5;
  var color1 = typeof foreground === 'string' ? (0, _color["default"])(foreground) : foreground;
  var color2 = typeof background === 'string' ? (0, _color["default"])(background) : background;
  return color1.contrast(color2) >= ratio;
};

exports.colorsAreAccessible = colorsAreAccessible;

var colorCanDarken = function colorCanDarken(color) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : minimumLuminoscity;

  if (!isColor(color)) {
    return null;
  }

  return (0, _color["default"])(color).hsl().object().l > min;
};

exports.colorCanDarken = colorCanDarken;

var colorCanLighten = function colorCanLighten(color) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : maximumLuminoscity;

  if (!isColor(color)) {
    return null;
  }

  return (0, _color["default"])(color).hsl().object().l < max;
};

exports.colorCanLighten = colorCanLighten;

var alternateColor = function alternateColor(color) {
  if (!isColor) {
    return null;
  }

  if (colorCanLighten(color)) {
    return (0, _color["default"])(color).lighten(0.5).mix(white, 0.2).hex();
  }

  return (0, _color["default"])(color).darken(0.2).hex();
};

exports.alternateColor = alternateColor;

var fadedColor = function fadedColor(color) {
  if (!isColor(color)) {
    return null;
  }

  return (0, _color["default"])(color).mix((0, _color["default"])('white'), 0.95);
};

exports.fadedColor = fadedColor;

var accessibleTextColor = function accessibleTextColor(color, background) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'AA';

  if (!isColor(color)) {
    return null;
  }

  var backgroundColor = background ? (0, _color["default"])(background) : (0, _color["default"])(color);
  var lightColor = almostWhiteColor(color);
  var darkColor = almostBlackColor(color);
  var colorOptions = [(0, _color["default"])(color), lightColor, darkColor, white, black];
  var passingColor = colorOptions.find(function (thisColor) {
    return colorsAreAccessible(backgroundColor, thisColor, level);
  });

  if (passingColor) {
    return passingColor;
  }

  var highestContrast = colorOptions.reduce(function (bestColor, currentColor) {
    if (!bestColor || backgroundColor.contrast(bestColor) < backgroundColor.contrast(currentColor)) {
      return currentColor;
    }

    return bestColor;
  });
  return highestContrast;
};

exports.accessibleTextColor = accessibleTextColor;

var colorizeWithCSSFilter = function colorizeWithCSSFilter(color) {
  return "brightness(0) invert(1) ".concat((0, _hexToCssFilter["default"])((0, _color["default"])(color).hex()).filter);
};

exports.colorizeWithCSSFilter = colorizeWithCSSFilter;